import { render, staticRenderFns } from "./DeleteStagiaire.vue?vue&type=template&id=ba43736a&"
import script from "./DeleteStagiaire.vue?vue&type=script&lang=js&"
export * from "./DeleteStagiaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports